import { courseApi, coursePackageApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const coursesApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCourseSuggestions: builder.query({
      query: () => ({
        url: courseApi(),
        method: 'POST',
        body: {
          data: {},
          method: 'suggestionList'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['CourseSuggestions'],
    }),
    fetchEditableCourses: builder.query({
      query: ({ searchText, showUncorrected }) => ({
        url: courseApi(),
        method: 'POST',
        body: {
          data: {
            searchText,
            showUncorrected
          },
          method: 'findBuildable'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['Courses'],
    }),
    fetchCoursesByGroupId: builder.query({
      query: ({ circleId, sortBy, sortMode }) => ({
        url: courseApi(),
        method: 'POST',
        body: {
          data: {
            circleId,
            sortMode,
            sortBy
          },
          method: 'findByCircleId'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { circleId }) => [
        { type: 'Courses', id: circleId },
        { type: 'Courses', id: 'LIST' }
      ],
    }),
    fetchEditablePackages: builder.query({
      query: () => ({
        url: coursePackageApi(),
        method: 'POST',
        body: {
          data: {},
          method: 'read'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['CoursePackages'],
    }),
    invalidateCoursesCache: builder.mutation({
      invalidatesTags: ['Courses'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchCourseSuggestionsQuery,
  useFetchEditableCoursesQuery,
  useFetchCoursesByGroupIdQuery,
  useFetchEditablePackagesQuery,
  useInvalidateCoursesCacheMutation,
} = coursesApiSlice;
